<template>
  <div class="reportWrapper">
    <template v-if="jsonReady">
      <div class="report-component" id="advisor-html-component">
        <h3 class="margin-bottom--quarter">
          {{ momentFormat(issue, 'MMMM YYYY') }} Report
        </h3>

        <div class="two-col-wrapper">
          <div
            class="col-inner background-grey-soft inner-padding rounded-corners-10"
          >
            <h4>{{ helpJsonContent.industry_snapshots.page_title }}</h4>
            <p>{{ helpJsonContent.industry_snapshots.body1 }}</p>

            <ul class="advisor-three-col-table-list">
              <template
                v-for="(value, index) in helpJsonContent.industry_snapshots"
                :key="index"
              >
                <li v-if="value.icon">
                  <span>
                    <img
                      :src="images_path + value.icon.attributes.href"
                      alt="ITR Advisor Image"
                    />
                  </span>
                  <span>{{ value.section_title1 }}</span>
                  <span>
                    <img
                      :src="images_path + value.icon_status.attributes.href"
                      alt="ITR Advisor Image"
                    />
                  </span>
                </li>
              </template>
            </ul>

            <ul class="advisor-legend-list">
              <li>
                <span>
                  <img
                    :src="
                      images_path +
                      helpJsonContent.industry_snapshots.arrow_legend
                        .steep_rise_icon.attributes.href
                    "
                    alt="ITR Advisor Image"
                  />
                </span>
                <span>
                  {{
                    helpJsonContent.industry_snapshots.arrow_legend.footnote1
                  }}
                </span>
              </li>
              <li>
                <span>
                  <img
                    :src="
                      images_path +
                      helpJsonContent.industry_snapshots.arrow_legend
                        .mid_rise_icon.attributes.href
                    "
                    alt="ITR Advisor Image"
                  />
                </span>
                <span>
                  {{
                    helpJsonContent.industry_snapshots.arrow_legend.footnote2
                  }}
                </span>
              </li>
              <li>
                <span>
                  <img
                    :src="
                      images_path +
                      helpJsonContent.industry_snapshots.arrow_legend.flat_icon
                        .attributes.href
                    "
                    alt="ITR Advisor Image"
                  />
                </span>
                <span>
                  {{
                    helpJsonContent.industry_snapshots.arrow_legend.footnote3
                  }}
                </span>
              </li>
              <li>
                <span>
                  <img
                    :src="
                      images_path +
                      helpJsonContent.industry_snapshots.arrow_legend
                        .mid_decline_icon.attributes.href
                    "
                    alt="ITR Advisor Image"
                  />
                </span>
                <span>
                  {{
                    helpJsonContent.industry_snapshots.arrow_legend.footnote4
                  }}
                </span>
              </li>
              <li>
                <span>
                  <img
                    :src="
                      images_path +
                      helpJsonContent.industry_snapshots.arrow_legend
                        .steep_decline_icon.attributes.href
                    "
                    alt="ITR Advisor Image"
                  />
                </span>
                <span>
                  {{
                    helpJsonContent.industry_snapshots.arrow_legend.footnote5
                  }}
                </span>
              </li>
            </ul>
          </div>

          <div class="col-inner inner-padding-top">
            <h4>{{ helpJsonContent.macroeconomic_outlook.page_title }}</h4>
            <p v-html="helpJsonContent.macroeconomic_outlook.body1"></p>
            <p class="tr-pull-quote">
              {{ helpJsonContent.macroeconomic_outlook.quote }}
            </p>
            <p v-html="helpJsonContent.macroeconomic_outlook.body2"></p>
          </div>
        </div>

        <div class="two-col-wrapper margin-top">
          <div
            class="col-inner background-green font-white inner-padding rounded-corners-10"
          >
            <h4>{{ helpJsonContent.make_your_move.page_title }}</h4>
            <p v-html="helpJsonContent.make_your_move.body1"></p>
          </div>

          <div
            class="col-inner background-green font-white inner-padding rounded-corners-10"
          >
            <h4>{{ helpJsonContent.investor_update.page_title }}</h4>
            <p v-html="helpJsonContent.investor_update.body1"></p>
          </div>
        </div>

        <div
          class="margin-top background-grey-soft inner-padding rounded-corners-10"
        >
          <h4>{{ helpJsonContent.long_term_view.page_title }}</h4>
          <div class="three-col-wrapper">
            <template
              v-for="(value, index) in helpJsonContent.long_term_view"
              :key="index"
            >
              <div class="col-inner" v-if="value.big_date">
                <div class="advisor-year-large">{{ value.big_date }}</div>
                <div class="advisor-capped-title">
                  {{ value.section_title1 }}
                </div>
              </div>
            </template>
          </div>
        </div>

        <div class="margin-top">
          <h4>{{ helpJsonContent.industry_analysis.page_title }}</h4>
          <div
            class="two-col-wrapper advisor-industry-analysis margin-top--quarter"
          >
            <template
              v-for="(value, index) in helpJsonContent.industry_analysis"
              :key="index"
            >
              <div class="col-inner" v-if="value.section_title1">
                <img
                  :src="images_path + value.icon.attributes.href"
                  alt="ITR Advisor Image"
                />
                <div>
                  <p class="advisor-capped-title">{{ value.section_title1 }}</p>
                  <ul>
                    <template v-for="(bullet, index) in value" :key="index">
                      <li v-if="index.includes('bullet')">{{ bullet }}</li>
                    </template>
                  </ul>
                </div>
              </div>
            </template>
          </div>
        </div>

        <h4 class="margin-top">
          {{ helpJsonContent.leading_indicator_snapshot.page_title }}
        </h4>

        <div class="table-responsive">
          <table class="tr-data-table table-min-width">
            <thead>
              <tr>
                <th></th>
                <th>
                  {{ helpJsonContent.leading_indicator_snapshot.row_head.col2 }}
                </th>
                <th>
                  {{ helpJsonContent.leading_indicator_snapshot.row_head.col3 }}
                </th>
                <th>
                  {{ helpJsonContent.leading_indicator_snapshot.row_head.col4 }}
                </th>
              </tr>
            </thead>
            <tbody>
              <template
                v-for="row in helpJsonContent.leading_indicator_snapshot.table"
                :key="index"
              >
                <tr>
                  <td>{{ row.col1 }}</td>
                  <td style="text-align: center">
                    <div
                      :class="
                        'advisor-circle advisor-circle--' +
                        row.col2.attributes.color
                      "
                    ></div>
                  </td>
                  <td style="text-align: center">
                    <div
                      :class="
                        'advisor-circle advisor-circle--' +
                        row.col3.attributes.color
                      "
                    ></div>
                  </td>
                  <td style="text-align: center">
                    <div
                      :class="
                        'advisor-circle advisor-circle--' +
                        row.col4.attributes.color
                      "
                    ></div>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>

        <div class="margin-top--quarter">
          <ul class="advisor-indicator-legend">
            <li>
              <span
                :class="
                  'advisor-circle-small advisor-circle--' +
                  helpJsonContent.leading_indicator_snapshot.legend.icon_green
                    .attributes.color
                "
              ></span>
              <span>
                {{
                  helpJsonContent.leading_indicator_snapshot.legend.footnote1
                }}
              </span>
            </li>
            <li>
              <span
                :class="
                  'advisor-circle-small advisor-circle--' +
                  helpJsonContent.leading_indicator_snapshot.legend.icon_red
                    .attributes.color
                "
              ></span>
              <span>
                {{
                  helpJsonContent.leading_indicator_snapshot.legend.footnote2
                }}
              </span>
            </li>
            <li>
              <span
                :class="
                  'advisor-circle-small advisor-circle--' +
                  helpJsonContent.leading_indicator_snapshot.legend.icon_gray
                    .attributes.color
                "
              ></span>
              <span>
                {{
                  helpJsonContent.leading_indicator_snapshot.legend.footnote3
                }}
              </span>
            </li>
          </ul>
        </div>

        <p class="advisor-capped-title margin-top--half">
          {{
            helpJsonContent.leading_indicator_snapshot.key_takeaways
              .section_title1
          }}
        </p>

        <ul>
          <template
            v-for="(value, key) in helpJsonContent.leading_indicator_snapshot
              .key_takeaways"
            :key="index"
          >
            <li v-if="!ignore.includes(key)">{{ value }}</li>
          </template>
        </ul>

        <h4 class="margin-top">{{ helpJsonContent.closer_look.page_title }}</h4>
        <h5>{{ helpJsonContent.closer_look.heading }}</h5>
        <p class="announcement-date">
          {{ helpJsonContent.closer_look.author }}
        </p>

        <div
          class="margin-top--quarter margin-bottom--quarter background-green inner-padding--half font-white intro rounded-corners-10"
        >
          <em>{{ helpJsonContent.closer_look.quote_white }}</em>
        </div>

        <template
          v-for="(value, index) in helpJsonContent.closer_look.content"
          :key="index"
        >
          <template v-if="index.includes('section_title')">
            <h4>{{ value }}</h4>
          </template>

          <template v-if="index.includes('body')">
            <p v-html="value"></p>
          </template>

          <template v-if="index.includes('bullet_list')">
            <ul>
              <li v-for="(bullet, index) in value" :key="index">
                {{ bullet }}
              </li>
            </ul>
          </template>

          <template v-if="index.includes('image')">
            <p class="text-center">
              <img
                :src="images_path + formatImageNames(value.attributes.href)"
                alt="Insider Advisor Report Image"
              />
            </p>
          </template>
        </template>

        <h4 class="margin-top">
          {{ helpJsonContent.state_by_state.page_title }}
        </h4>

        <p class="text-center">
          <img
            :src="
              images_path +
              formatImageNames(
                helpJsonContent.state_by_state.image1.attributes.href
              )
            "
            alt="Inside Advisor Report Image"
          />
        </p>

        <ul>
          <template
            v-for="(value, key) in helpJsonContent.state_by_state"
            :key="key"
          >
            <li v-if="!ignore.includes(key)">{{ value }}</li>
          </template>
        </ul>

        <h4 class="margin-top">
          {{ helpJsonContent.readers_forum.page_title }}
        </h4>
        <h5 class="margin-bottom--quarter">
          {{ helpJsonContent.readers_forum.heading }}
        </h5>
        <p
          v-html="helpJsonContent.readers_forum.small_title"
          class="announcement-date"
        ></p>
        <p v-html="helpJsonContent.readers_forum.body1"></p>
        <p>
          {{ helpJsonContent.readers_forum.body2 }}
          <a :href="helpJsonContent.meta.link1" target="_blank">
            {{ helpJsonContent.readers_forum.text_link }}
          </a>
        </p>

        <div
          class="advisor-cta-block margin-top background-grey-soft inner-padding rounded-corners-10"
        >
          <div class="two-col-wrapper middle-align">
            <div class="col-inner">
              <img
                :src="
                  images_path +
                  formatImageNames(helpJsonContent.cta.image1.attributes.href)
                "
                alt="Inside Advisor Report Image"
              />
            </div>
            <div class="col-inner">
              <h4>{{ helpJsonContent.cta.heading }}</h4>
              <p v-html="helpJsonContent.cta.body1"></p>
              <p>
                <a
                  :href="helpJsonContent.meta.link2"
                  target="_blank"
                  class="button-green"
                >
                  {{ helpJsonContent.cta.button }}
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
  import moment from 'moment';
  import _ from 'lodash';
  export default {
    props: {
      content: {
        type: String,
        required: true,
      },
      imagespath: {
        type: String,
        required: true,
      },
      issue: {
        type: String,
        required: false,
      },
    },
    data: function () {
      return {
        parsed: {},
        jsonReady: true,
        summary: '',
        images_path: this.imagespath,
        issue_test: '2019-02-01 00:00:00',
        jsonContent: JSON.parse(this.content),
        ignore: ['page_title', 'image1', 'section_title1'],
      };
    },
    computed: {
      helpJsonContent: function () {
        //return JSON.parse(this.content.replace("\\u2029 | \\u2028", "<br>"));
        return JSON.parse(this.content);
      },

      takeawayItems() {
        return JSON.parse(
          this.content
        ).leading_indicator_snapshot.key_takeaways.splice(0, 1);
      },
    },
    methods: {
      momentFormat(date, format) {
        return moment(date).format(format);
      },
      objectKeyExists: function (object_path, key) {
        return this.containsKey(object_path, key);
      },
      containsKey(obj, key) {
        return Object.keys(obj).includes(key);
      },
      getKey: function (object_path) {
        var keyExists = _.get(this.jsonContent, object_path, 0);

        if (keyExists !== 0) {
          return true;
        }
        return false;
      },
      parseJson: function () {
        this.jsonReady = true;
      },
      convertToHyphens: function (value) {
        return value.replace(/_/g, '-');
      },

      formatImageNames: function (value) {
        return value.replace(/%20/g, '_');
      },
    },
  };
  //https://stackoverflow.com/questions/13869627/unable-to-access-json-property-with-dash  jsonObj.profile - id
  //To access a key that contains characters that cannot appear in an identifier, use brackets: jsonObj["profile-id"]
</script>
